// src/recent-searches/recentSearchesApi.ts
import { apiClient } from "@maat/api-base";
var recentSearchesApi = {
  list: async (params) => {
    return apiClient.get("/main/api/recent-searches", { params });
  },
  record: async (payload) => {
    await apiClient.post("/main/api/recent-searches", payload);
  },
  dismiss: async (id) => {
    await apiClient.delete(`/main/api/recent-searches/${id}`);
  }
};

export {
  recentSearchesApi
};
